module.exports = __webpack_public_path__ + "img/carita_padecimiento.0d1b1e6f.svg";